import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-modal-side-panel',
    templateUrl: './modal-side-panel.component.html',
    styleUrls: ['./modal-side-panel.component.scss'],
    standalone: false
})
export class ModalSidePanelComponent implements OnInit {
    @Input() open?: boolean;

    constructor() {}

    ngOnInit(): void {}
}
